import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler
{
	handleError(error: any): void
	{
		// Centralized logging only. No navigation or user redirection.
		console.error('[GlobalErrorHandler]', error);

		//if the error is an HttpErrorResponse, and is 401, log out
		if (error instanceof HttpErrorResponse) 
		{
			switch (error.status)
			{
				case 401:
					console.log('Unauthorized error - user should be logged out.');
					//redirect the user to the login page
					//go to root page
					location.href = '/';
					break;
				default:
					console.error('HTTP Error:', error.message);
					break;
			}
		}
	}
}
